'use client';

import '@/server/utils/setupEnv';

import React from 'react';

import { Link } from '@/server/components/Button/';
import { ButtonLink } from '@/server/components/Button/ButtonLink';
import { sizeClassnames, variantClassnames } from '@/server/components/Button/helpers';
import { DeviceType, generateDownloadLink, getDeviceType } from '@/server/utils/generateDownloadLink';

export const Client = ({
  text = 'Download BFF',
  size = 'md',
  variant = { _type: 'button', variant: 'highlighter' },
  linkFallback,
  copyToClipboard = false,
  useSchema = false,
  initialDevice,
  initialReferer,
  disableDarkMode = false,
}: {
  linkFallback?: string;
  text?: string;
  size?: keyof typeof sizeClassnames;
  variant?:
    | { _type: 'button'; variant: keyof typeof variantClassnames }
    | { _type: 'link'; variant: keyof typeof variantClassnames };
  copyToClipboard?: boolean;
  useSchema?: boolean;
  initialDevice: DeviceType;
  initialReferer: string;
  disableDarkMode?: boolean;
}) => {
  const device =
    typeof window === 'undefined' ? initialDevice : getDeviceType(window.navigator.userAgent.toLowerCase());
  const referer = typeof window === 'undefined' ? initialReferer : window.location.href;

  const { href, useWindow, clipboardTarget } = generateDownloadLink({
    env: ENV,
    useSchema,
    referer,
    linkFallback,
    device,
  });

  if (variant._type === 'button') {
    return (
      <ButtonLink
        href={href}
        variant={variant.variant}
        size={size}
        useWindow={useWindow}
        clipboardTarget={clipboardTarget}
        disableDarkMode={disableDarkMode}
      >
        {text}
      </ButtonLink>
    );
  } else {
    return (
      <Link href={href} variant={variant.variant} disableDarkMode={disableDarkMode}>
        {text}
      </Link>
    );
  }
};
